import React from 'react';
import styled from 'styled-components';

import { Body } from './AddSectionModal.stc';
import { ElementContext } from '../../../../ElementRenderContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Section = styled(Body)`
    display: grid;
    grid-gap: 25px;
    grid-template-columns: repeat(4, 1fr);
`;
const ElementItem = styled.div`
    padding: 20px;
    cursor: pointer;
    text-align: center;
    position: relative;
    border-radius: 5px;
    color: var(--color-body-text-300);
    border: 2px solid ${({ theme }) => theme.borderPaleGrey};

    p,
    svg {
        opacity: ${({ isActive }) => (isActive ? '1' : '0.5')};
    }

    .pro-element {
        top: 5px;
        right: 5px;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        padding: 3px 6px;
        position: absolute;
        border-radius: 3px;
        display: inline-block;
        background: var(--color-primary-500);
    }
`;
const Text = styled.p`
    margin: 10px 0 0;
    /* color: var(--color-text-700); */
`;

function Element({ item, validateMembership }) {
    const { data, membership } = item;
    const isVisibleElement = validateMembership(membership);

    const { addElement } = React.useContext(ElementContext);
    const handleClick = React.useCallback(
        () =>
            isVisibleElement
                ? addElement({ data, elType: data._elType })
                : window.open('/dashboard/account/billing', '_blank'),
        [addElement, data, isVisibleElement]
    );
    return (
        <ElementItem isActive={isVisibleElement} onClick={handleClick}>
            {membership && (
                <span title={membership} className="pro-element">
                    Pro
                </span>
            )}
            <FontAwesomeIcon
                size="2x"
                fixedWidth
                icon={item.icon}
                className="icon"
            />
            <Text>{item.title}</Text>
        </ElementItem>
    );
}

function DefaultElement({ data = [], ...restOfProps }) {
    return (
        <Section>
            {data.map((item, idx) => (
                <Element key={idx} item={item} {...restOfProps} />
            ))}
        </Section>
    );
}

export default DefaultElement;
